<script>

// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
// https://codechips.me/svelte-cross-component-communication/
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=

import { onMount, onDestroy } from 'svelte';

import { account_service       , account_service_context_key        } from './_services/account.js';
import { loggedIn                                                   } from './_services/accountsession.js';
import { cookiejar_service     , cookiejar_service_context_key      } from './_services/cookiejar.js';
	
	onMount(async () => {
 	});

	onDestroy(() => { 
	});


</script>

<style>

#footer {
  visibility: visible;
  display: block;
  position: fixed;
  bottom: 0px;
  width: 100%;
  height: 30px;
  left: 0px;
  background-color: #72060d;
  color: #231105;
box-shadow: 0px 0px 3px 0px black;
  font-family: "sans-serif";
  z-index: 999;
  text-align: right;
  padding: 3px;
  font-size: small;
}
</style>

<div id="footer">
	<p> &copy; artificiality </p>
</div>
